// TripsPage.tsx — /trips. My Trips page with Upcoming / Past / Cancelled tabs.
// TODO(trips-api-PR): Replace UPCOMING_TRIPS/PAST_TRIPS/CANCELLED_TRIPS mock with
// real GET /bookings?userId=me&status=upcoming|past|cancelled when trips BE lands.

import { useState } from 'react';
import { SiteFooter } from '@/components/SiteFooter';
import { TripCard } from '@/components/TripCard';
import { EmptyState } from '@/components/primitives';
import { UPCOMING_TRIPS, PAST_TRIPS, CANCELLED_TRIPS } from '@/lib/trips-mock';

const F = '"Inter Variable","Inter",system-ui,sans-serif';
const DISPLAY = '"Fraunces Variable","Fraunces",Georgia,serif';

const T = {
  bg: '#0A0F1C', ink: '#F4F3F0', inkDim: '#8C98B0',
  primary: '#E8441A', line: 'rgba(255,255,255,0.07)', lineHi: 'rgba(255,255,255,0.14)',
};

type Tab = 'upcoming' | 'past' | 'cancelled';

const TAB_DATA: Record<Tab, { label: string; count: number }> = {
  upcoming:  { label: 'Upcoming',  count: UPCOMING_TRIPS.length },
  past:      { label: 'Past',      count: PAST_TRIPS.length },
  cancelled: { label: 'Cancelled', count: CANCELLED_TRIPS.length },
};

export function TripsPage() {
  const [activeTab, setActiveTab] = useState<Tab>('upcoming');

  const trips =
    activeTab === 'upcoming'  ? UPCOMING_TRIPS :
    activeTab === 'past'      ? PAST_TRIPS :
                                CANCELLED_TRIPS;

  return (
    <div style={{ background: T.bg, minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ padding: '48px clamp(16px, 4vw, 64px) 0' }}>
        <div style={{ fontFamily: F, fontSize: 11, letterSpacing: 2.5, color: T.inkDim, fontWeight: 600 }}>
          YOUR TRAVEL HISTORY
        </div>
        <h1 style={{
          fontFamily: DISPLAY,
          fontSize: 'clamp(48px,6vw,80px)',
          fontWeight: 500,
          color: T.ink,
          margin: '8px 0 0',
          lineHeight: 0.92,
          letterSpacing: -0.03,
        }}>
          My trips.
        </h1>
      </div>

      {/* Tab strip */}
      <div style={{ padding: '32px clamp(16px, 4vw, 64px) 0' }}>
        <div style={{
          display: 'inline-flex',
          gap: 4,
          padding: 4,
          background: '#0F1628',
          borderRadius: 16,
          border: `1px solid ${T.line}`,
        }}>
          {(Object.keys(TAB_DATA) as Tab[]).map(tab => {
            const isActive = activeTab === tab;
            const meta = TAB_DATA[tab];
            return (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  height: 42,
                  padding: '0 20px',
                  borderRadius: 12,
                  border: 'none',
                  cursor: 'pointer',
                  fontFamily: F,
                  fontSize: 14,
                  fontWeight: isActive ? 700 : 500,
                  background: isActive ? '#131C30' : 'transparent',
                  color: isActive ? T.ink : T.inkDim,
                  transition: 'all 0.15s',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                {meta.label}
                {meta.count > 0 && (
                  <span style={{
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: isActive ? T.primary : 'rgba(255,255,255,0.1)',
                    color: '#fff',
                    fontFamily: F,
                    fontSize: 11,
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>{meta.count}</span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Trip cards */}
      <div style={{ padding: '24px clamp(16px, 4vw, 64px)', maxWidth: 1200 }}>
        {trips.length === 0 ? (
          <EmptyState
            title="No trips here"
            body={
              activeTab === 'upcoming'
                ? "Book your next adventure and it'll show up here."
                : "No trips in this category yet."
            }
          />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {trips.map(trip => (
              <TripCard key={trip.id} trip={trip} />
            ))}
          </div>
        )}
      </div>

      <SiteFooter/>
    </div>
  );
}
